module.exports = __webpack_public_path__ + "img/art.d70b038b.svg";